"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;
exports.up = up;

var _omegaTracker = _interopRequireDefault(require("@didi/omega-tracker"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function up(args) {
  this.Omega.trackEvent(this.omegaKey, args);
}

function init(_ref) {
  let {
    appKey,
    uploadHost,
    omegaKey
  } = _ref;
  this.omegaKey = omegaKey;
  this.Omega = _omegaTracker.default.getTracker({
    appKey,
    uploadHost
  });
}